// React imports
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { RootState } from "app/store";
import { setIsMenuOpen, setIsSaveDialogOpen } from "./headerSlice";

// styled-components imports
import StyledBrandButton from "./styled-components/StyledBrandButton";
import StyledHeader from "./styled-components/StyledHeader";
import StyledMenuButton from "./styled-components/StyledMenuButton";
import StyledNav from "./styled-components/StyledNav";
import StyledSaveButton from "./styled-components/StyledSaveButton";

// Icon imports
import CloseMenuIcon from "common/svg/CloseMenuIcon";
import FloppyDiskIcon from "common/svg/FloppyDiskIcon";
import IsotypeColor from "common/svg/IsotypeColor";
import IsotypeWhite from "common/svg/IsotypeWhite";
import LogoColor from "common/svg/LogoColor";
import LogoWhite from "common/svg/LogoWhite";
import MenuIcon from "common/svg/MenuIcon";

function Header() {
  const dispatch = useDispatch();
  const history = useHistory();
  const isSaveDialogOpen = useSelector(
    (state: RootState) => state.header.save.isDialogOpen
  );
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );
  const menuColor = useSelector((state: RootState) => state.header.menu.color);
  const isMenuOpen = useSelector(
    (state: RootState) => state.header.menu.isMenuOpen
  );

  const headerAction = useSelector((state: RootState) => state.header.action);
  const colorMode = useSelector((state: RootState) => state.header.colorMode);
  const widthMode = useSelector((state: RootState) => state.header.widthMode);

  function handleBrandClick() {
    //history.push("/");
    window.location.href = 'https://digien.io'; 
  }

  function handleSaveAction() {
    dispatch(setIsSaveDialogOpen(!isSaveDialogOpen));
  }

  function handleOpenMenuAction() {
    dispatch(setIsMenuOpen(true));
  }

  function handleCloseMenuAction() {
    dispatch(setIsMenuOpen(false));
  }

  return (
    <StyledHeader widthMode={widthMode}>
      <StyledNav>
        <StyledBrandButton onClick={handleBrandClick}>
          {colorMode === "unicolor" ? (
            upDesktopScreen ? (
              <LogoWhite />
            ) : (
              <IsotypeWhite />
            )
          ) : upDesktopScreen ? (
            <LogoColor />
          ) : (
            <IsotypeColor />
          )}
        </StyledBrandButton>
        {headerAction === "save" && (
          <StyledSaveButton onClick={handleSaveAction}>
            <span>Guardar</span>
            <FloppyDiskIcon />
          </StyledSaveButton>
        )}
        {headerAction === "menu" && !isMenuOpen && (
          <StyledMenuButton onClick={handleOpenMenuAction}>
            <MenuIcon size={upDesktopScreen ? 60 : 31} color={menuColor} />
          </StyledMenuButton>
        )}
        {headerAction === "menu" && isMenuOpen && (
          <StyledMenuButton onClick={handleCloseMenuAction}>
            <CloseMenuIcon size={upDesktopScreen ? 60 : 31} />
          </StyledMenuButton>
        )}
      </StyledNav>
    </StyledHeader>
  );
}

export default Header;
